import React from 'react';
import { Link } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form, Button } from 'react-bootstrap';
import { Input, Checkbox, FormActions } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';

const SettingsForm = ({ error, handleSubmit, pristine, submitting, isReadonly, submitSucceeded, t }) => {
	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			<Field name='name' component={Input} disabled={isReadonly} horizontal required type='text' label={t('Role_Name')} validate={validators.required} />
			<Field name='description' component={Input} disabled={isReadonly} horizontal required label={t('Role_Description')} validate={[validators.required]} />
			<Field name='enabled' component={Checkbox} disabled={isReadonly} horizontal label={t('Role_Enabled')} normalize={(v) => { return !!v }} />
			<FormActions horizontal>
				<Link to='/roles' className='btn btn-default'>{t('Common_BackToList')}</Link>
				<Button type='submit' disabled={isReadonly || pristine || submitting || isReadonly} bsStyle='primary'>{t('Common_Save')}</Button>
			</FormActions>
		</Form>
	);
};

export default reduxForm({ form: 'role', enableReinitialize: true })(withTranslation()(SettingsForm));
